import { gql } from '@apollo/client'

const BRANDS_WITH_NO_TOP_200_MENU_QUERY = gql`
  query brandsWithNoTop200MenuQuery {
    brandsWithNoTop200Menu {
      id
      name
    }
  }
`

export default BRANDS_WITH_NO_TOP_200_MENU_QUERY
